import React, { useState, useEffect } from "react";
import Select from 'react-select'
import { Modal, Input, Button, ModalQuiz } from '../../util/ui';
import '../../util/Quiz.css'; // Import the CSS file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';

const EditQuestionModal = ({ isOpen, setIsOpen, onEditQuestion, question_obj }) => {
    const [questionPrompt, setQuestionPrompt] = useState("");
    // const [questionCourse, setQuestionCourse] = useState("");
    const [options, setOptions] = useState("");
    // const [selectedOptions, setSelectedOptions] = useState([]);
    const [newOptionName, setNewOptionName] = useState("");
    const [newOptionSelected, setNewOptionSelected] = useState(false);
    const [questionObject, setQuestionObject] = useState("");
    const [editingOptionId, setEditingOptionId] = useState(null);
    const [editedOptionName, setEditedOptionName] = useState("");
    const [questionType, setQuestionType] = useState("Select One");

    useEffect(() => {
        if (isOpen && question_obj) {
            setQuestionObject(question_obj);
            setQuestionPrompt(question_obj.prompt);
            setQuestionType(question_obj._type)
            console.log(question_obj);
            const transformedOptions = question_obj.choices.map((choice, index) => ({
                id: index + 1,
                title: choice,
                selected: question_obj.answers.includes(choice)
            }));
            setOptions(transformedOptions);
            // setOptions([
            //     {id: 1, selected: false, title: "Option 1"},
            //     {id: 2, selected: true, title: "Option 2"},
            //     {id: 3, selected: false, title: "Option 3"},
            // ]);
        } else {
            setQuestionPrompt("");
            setOptions([]);
        }
    }, [isOpen, question_obj]);

    const topic_options = [
        { value: 'query', label: 'Query' },
        { value: 'data_cln', label: 'Data Cleaning' },
        { value: 'data_pro', label: 'Data Preprocessing' },
        { value: 'data_viz', label: 'Data Visualization' },
        { value: 'feat_eng', label: 'Feature Engineering' },
        { value: 'feat_sel', label: 'Feature Selection' },
        { value: 'analysis', label: 'Analysis' }
      ]

    const questionTypeOptions = [
    { value: 'Select One', label: 'Select One' },
    { value: 'ChooseAllThatApplyQuestion', label: 'Select Multiple' },
    ];

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate that the question prompt is not empty
        if (questionPrompt.trim() === "") {
            alert("Question prompt cannot be empty.");
            return;
        }
        // Check if there are at least two options
        if (options.length < 2) {
            alert("Please provide at least two options.");
            return;
        }
    
        // Check if at least one option is selected
        const isAnyOptionSelected = options.some(option => option.selected);
    
        if (!isAnyOptionSelected) {
            alert("Please select at least one option.");
            return;
        }

        const author = JSON.parse(localStorage.getItem("user")).username;
        // Update question object
        question_obj.prompt = questionPrompt
        question_obj.choices = options.map(option => option.title);
        question_obj.answers = options.filter(option => option.selected).map(option => option.title);
        question_obj.options = options
        question_obj.type = questionType
        console.log("Updated Qn Obj: ", question_obj );
        // question_obj.id = question_obj._id.$oid,
        onEditQuestion(question_obj);
        // Close the modal
        setIsOpen(false);
    };

    const handleOptionCreate = (option, isChecked) => {
        console.log("option: ", newOptionName);
        console.log("option len: ", newOptionName.length);
        if (!newOptionName) {
            // Handle empty option case here (e.g., show an error message, return early)
            alert("Option is empty. Please provide a valid option.");
            return;
        }
        const newId = options.length > 0 ? options[options.length - 1].id + 1 : 1;
        const newOption = { id: newId, selected: newOptionSelected, title: newOptionName };
        setOptions([...options, newOption]);
        
        console.log("qn: ", questionPrompt);
        // console.log("topic: ", questionCourse);
        console.log("op: ", options);
        setNewOptionName("");
        setNewOptionSelected(false);
      };

    const handleEditOptionClick = (option) => {
        setEditingOptionId(option.id);
        setEditedOptionName(option.title);
    };

    const handleDeleteOptionClick = (option) => {
        setOptions(options.filter((opt) => opt.id !== option.id));
    };

    const handleEditOptionSubmit = (optionId) => {
        setOptions(options.map(opt => 
            opt.id === optionId ? { ...opt, title: editedOptionName } : opt
        ));
        setEditingOptionId(null);
        setEditedOptionName("");
    };

    return (
        <ModalQuiz isOpen={isOpen} setIsOpen={setIsOpen} ClassName="question-modal" clickBgToClose={false}>
            {/* <form onSubmit={handleSubmit}> */}
                <h2>Edit Question</h2>
                <label>Question Prompt:</label>
                <input
                    type="text"
                    placeholder="Title"
                    value={questionPrompt}
                    onChange={(e) => setQuestionPrompt(e.target.value)}
                    required
                />
                <label>Question Type:</label>
                <Select
                options={questionTypeOptions}
                value={questionTypeOptions.find(option => option.value === questionType)}  // Dynamically set value
                onChange={(selectedOption) => setQuestionType(selectedOption.value)}
                />

                <span>Answers:</span>
                {options &&
                    options.map((obj, i) => (
                        <div key={obj.id}>
                            {editingOptionId === obj.id ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        type="text"
                                        value={editedOptionName}
                                        onChange={(e) => setEditedOptionName(e.target.value)}
                                    />
                                    <button 
                                        onClick={() => handleEditOptionSubmit(obj.id)}
                                        style={{ background: 'green', color: 'white' }}>
                                        Submit
                                    </button>
                                    <button 
                                        onClick={() => setEditingOptionId(null)} 
                                        style={{ background: 'grey', color: 'white' }}>
                                        Cancel
                                    </button>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                    <div style={{ flex: 1, display: 'flex' }}>
                                        <input
                                            style={{width: 'auto' }}
                                            className="quiz-page-radio-input"
                                            type="radio"
                                            name={`option_${obj.id}`}
                                            value={obj.id}
                                            onClick={(e) => {
                                                setOptions(prevOptions =>
                                                    prevOptions.map(option =>
                                                        option.id === obj.id ? { ...option, selected: !option.selected } : option
                                                    )
                                                );
                                                console.log("options: ", options);
                                            }}
                                            checked={obj.selected}
                                            readOnly
                                        />
                                        <span className="quiz-page-option-prompt quiz-page-radio-input-prompt">{obj.title}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <button onClick={() => handleEditOptionClick(obj)} 
                                        style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'blue', marginRight: '10px' }}>
                                        <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        <button onClick={() => handleDeleteOptionClick(obj)} 
                                        style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'red' }}>
                                        <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                ))}
                
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                        style={{width: 'auto' }}
                        className="quiz-page-radio-input"
                        type="radio"
                        name={`new_option`}
                        onClick={(e) => {
                            // const isChecked = e.target.checked;
                            // setNewOptionSelected(isChecked);
                            setNewOptionSelected(prevState => !prevState);
                        }}
                        checked={newOptionSelected}
                        readOnly
                    />
                    <input className="quiz-page-option-prompt quiz-page-radio-input-prompt" type="text" 
                        value={newOptionName ? newOptionName : ''}
                        onChange={(e) => setNewOptionName(e.target.value)}
                        placeholder="Type option here ..."/>
                    <button type="button" 
                        style={{ marginBottom: '10px', marginLeft: '10px' }}
                        onClick={handleOptionCreate}
                        className="btn btn-sm btn-secondary">Create Option</button>
                </div>                        
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                    <button onClick={handleSubmit} 
                            className="btn btn-primary" type="button">
                        Edit Question
                    </button>
                    <button 
                        onClick={() => setIsOpen(false)} 
                        className="btn btn-danger"
                        type="button">
                        Cancel
                    </button>
                </div>
            {/* </form> */}
        </ModalQuiz>
    );
};

export default EditQuestionModal;